var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, ManyToOne, PrimaryColumn, Unique } from 'typeorm';
import { Test } from './test.js';
let Deployment = class Deployment {
    id;
    createdDate;
    project;
    projectId;
    test;
    testId;
    snapshotId;
    signature;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Deployment.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Deployment.prototype, "createdDate", void 0);
__decorate([
    Index(),
    ManyToOne('Project', { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Function)
], Deployment.prototype, "project", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], Deployment.prototype, "projectId", void 0);
__decorate([
    Index(),
    ManyToOne(() => Test, { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Test)
], Deployment.prototype, "test", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], Deployment.prototype, "testId", void 0);
__decorate([
    Index(),
    Column('uuid'),
    __metadata("design:type", String)
], Deployment.prototype, "snapshotId", void 0);
__decorate([
    Column({ nullable: false, default: 'N/A' }),
    __metadata("design:type", String)
], Deployment.prototype, "signature", void 0);
Deployment = __decorate([
    Entity(),
    Unique(['projectId', 'testId', 'signature'])
], Deployment);
export { Deployment };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVwbG95bWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kb21haW4vbW9kZWxzL2RlcGxveW1lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3pDLE9BQU8sRUFBRSxNQUFNLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsYUFBYSxFQUFFLE1BQU0sRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUVwRyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBSTFCLElBQU0sVUFBVSxHQUFoQixNQUFNLFVBQVU7SUFFckIsRUFBRSxDQUFVO0lBSVosV0FBVyxDQUFRO0lBSW5CLE9BQU8sQ0FBVztJQUdsQixTQUFTLENBQVU7SUFJbkIsSUFBSSxDQUFRO0lBR1osTUFBTSxDQUFVO0lBSWhCLFVBQVUsQ0FBVTtJQUdwQixTQUFTLENBQVU7Q0FDcEIsQ0FBQTtBQTFCQztJQURDLGFBQWEsQ0FBQyxNQUFNLEVBQUUsRUFBRSxPQUFPLEVBQUUsR0FBRyxFQUFFLENBQUMsVUFBVSxFQUFFLENBQUM7O3NDQUN6QztBQUlaO0lBRkMsZ0JBQWdCLENBQUMsRUFBRSxJQUFJLEVBQUUsYUFBYSxFQUFFLENBQUM7SUFDekMsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQzs4QkFDSCxJQUFJOytDQUFDO0FBSW5CO0lBRkMsS0FBSyxFQUFFO0lBQ1AsU0FBUyxDQUFDLFNBQVMsRUFBRSxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFLFNBQVMsRUFBRSxDQUFDOzsyQ0FDN0M7QUFHbEI7SUFEQyxNQUFNLENBQUMsTUFBTSxDQUFDOzs2Q0FDSTtBQUluQjtJQUZDLEtBQUssRUFBRTtJQUNQLFNBQVMsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLEVBQUUsRUFBRSxRQUFRLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRSxTQUFTLEVBQUUsQ0FBQzs4QkFDekQsSUFBSTt3Q0FBQztBQUdaO0lBREMsTUFBTSxDQUFDLE1BQU0sQ0FBQzs7MENBQ0M7QUFJaEI7SUFGQyxLQUFLLEVBQUU7SUFDUCxNQUFNLENBQUMsTUFBTSxDQUFDOzs4Q0FDSztBQUdwQjtJQURDLE1BQU0sQ0FBQyxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxDQUFDOzs2Q0FDekI7QUEzQlIsVUFBVTtJQUZ0QixNQUFNLEVBQUU7SUFDUixNQUFNLENBQUMsQ0FBQyxXQUFXLEVBQUUsUUFBUSxFQUFFLFdBQVcsQ0FBQyxDQUFDO0dBQ2hDLFVBQVUsQ0E0QnRCIn0=